"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=WebVitalsEvent.js.map